export const moneyFormat = (val, { isTwoDecimal = true, keepInteger = true, isParseFloat = true, isIntegerValue, isNeedDivide, divisor = 10000, f = Math.round } = {}) => {
  const { isNaN } = Number
  let multiplier = 1
  let decimal = 0
  let num = Number(val)
  if (isNaN(num)) {
    return ''
  }
  if (keepInteger && num % 1 === 0) {
    return num
  }
  if (isTwoDecimal) {
    multiplier = 100
    decimal = 2
  }
  if (isIntegerValue) {
    multiplier = 1
    decimal = 0
  }
  if (!isNeedDivide) divisor = 1
  num = f(num / divisor * multiplier) / multiplier
  return isParseFloat ? parseFloat(num) : num.toFixed(decimal)
}

const multiple = 1024
const { isInteger, parseFloat, isNaN } = Number
const { abs } = Math
/**
 *
 * @param volume M
 * @param whether 是否需要带单位，默认为true
 * @param unit
 * @returns {*}
 */
export const volumeFormat = function(volume, whether = true, unit = 'M') {
  const units = unit === 'M' ? ['M', 'G'] : ['K', 'M']
  if (isNaN(+volume)) return volume
  if (typeof volume === 'string') volume = parseFloat(volume)
  // 小于 1G
  if (abs(volume) < 1024) {
    // 包含小数
    if (!isInteger(volume)) volume = volume.toFixed(3)
    return volume + (whether ? units[0] : '')
  }
  volume /= multiple
  // 转成G包含小数
  if (!isInteger(volume)) volume = volume.toFixed(3)
  return volume + (whether ? units[1] : '')
}

/**
 * 秒数格式化
 * @param seconds
 * @param format
 * @returns {string}
 */
export const secondsFormat = (seconds, format) => {
  if (!seconds) {
    return ''
  }
  const hour = Math.floor(seconds / 3600).toString()
  const minute = Math.floor(seconds % 3600 / 60).toString()
  const second = Math.floor(seconds % 60).toString()
  if (format) {
    return format.replace('%h', hour).replace('%m', minute).replace('%s', second)
  }
  return `${hour}h${minute}m${second}s`
}
